<template>
  <div class="font-medium">
    <span v-if="naanAmount === 1" class="inline-block">Where’s the naan, Jeremy?</span>
    <span v-if="naanAmount === 2" class="inline-block">Chance would be a fine thing.</span>
    <span v-if="naanAmount === 3" class="inline-block">Yes! "I am the lord of the naan!” said he.</span>
    <span v-if="naanAmount === 5 || naanAmount > 9" class="inline-block">Luckily we’re all English so no-one’s going to ask any questions.</span>
    <span v-if="naanAmount === 6" class="inline-block">I’ll tell you what, that naan is really moreish.</span>
    <span v-if="naanAmount === 7" class="inline-block">This was definitely a good idea. There’s no chance this wasn’t a good idea.</span>
    <span v-if="naanAmount === 8" class="inline-block">It doesn’t sound normal, Mark. It doesn’t smell normal.</span>
    <span v-if="naanAmount === 9" class="inline-block">It’s Moroccan.</span>
  </div>
</template>
<script>
export default {
  name: 'DescriptionResultComponent',
  props: {
    naanAmount: {
      type: Number,
    },
  },
}
</script>
